import { render } from "./TopMoviesToday.vue?vue&type=template&id=946aff74&ts=true"
import script from "./TopMoviesToday.vue?vue&type=script&lang=ts"
export * from "./TopMoviesToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__